export const carsLinks = [
  { href: '/new-cars-offers/astra', name: 'Astra' },
  { href: '/new-cars-offers/astra-sports-tourer', name: 'Astra Sports Tourer' },
  { href: '/new-cars-offers/new-corsa', name: 'Corsa' },
  { href: '/new-cars-offers/combo-e-life', name: 'Combo Life electric' },
  { href: '/new-cars-offers/crossland', name: 'Crossland' },
  { href: '/new-cars-offers/grandland', name: 'Grandland' },
  { href: '/new-cars-offers/mokka', name: 'Mokka' },
  { href: '/new-cars-offers/mokka-electric', name: 'Mokka Electric' },
  {
    href: '/new-cars-offers/vivaro-life-electric',
    name: 'Vivaro Life Electric',
  },
]

export const newArrivalsLinks = [
  { href: '/astra-griffin', name: 'Astra Griffin' },
  { href: '/corsa-hybrid', name: 'Corsa Hybrid' },
  { href: '/yes-corsa', name: 'Corsa Yes Edition' },
  { href: '/mokka-griffin', name: 'Mokka Griffin' },
  { href: '/new-grandland', name: 'New Grandland' },
]

export const comingSoonLinks = [{ href: '/new-frontera', name: 'New Frontera' }]

export const vansLinks = [
  { href: '/new-vans-offers/combo-cargo', name: 'Combo' },
  { href: '/new-vans-offers/e-combo-cargo', name: 'Combo Electric' },
  { href: '/new-vans-offers/vivaro', name: 'Vivaro' },
  { href: '/new-vans-offers/vivaro-electric', name: 'Vivaro Electric' },
  { href: '/new-vans-offers/movano', name: 'New Movano' },
  { href: '/new-vans-offers/movano-electric', name: 'New Movano Electric' },
]

export const electricLinks = [{ href: '/electric-cars', name: 'Electric vehicles' }]

export const stockLinks = [
  { href: '/stock-cars', name: 'Stock Used Cars' },
  { href: '/stock-cars', name: 'Stock New Cars' },
]

export const serviceLinks = [
  { href: '/service-booking', name: 'Online Service & MOT booking' },
  { href: '/value-car', name: 'Value Your Car' },
  { href: '/service-special-offer', name: 'Service Special Offer' },
  { href: '/vehicle-health-check', name: 'Vehicle Health Check' },
  { href: '/online-payment', name: 'Online Payment' },
  { href: '/part-request', name: 'Part Request' },
  { href: '/service-plan', name: 'Service Plan' },
  { href: '/rac-breakdown-cover', name: 'Free RAC' },
  { href: '/drive-now-pay-later', name: 'Drive now pay later' },
  { href: '/motability-car-scheme', name: 'Motability' },
  { href: '/finance-explained', name: 'Finance Explained' },
]

export const newsLinks = [{ href: '/news', name: 'News & Articles' }]

export const bottomLinks = [
  { href: '/privacy-policy', name: 'Privacy & Legal' },
  { href: '/reservation-policy', name: 'Reservation policy' },
  { href: '/terms-conditions', name: 'Terms and Conditions' },
  { href: '/marketing-consent', name: 'Marketing Consent' },
  { href: '/refund', name: 'Refund form' },
  { href: '/contact-us', name: 'Contact Us' },
  { href: '/about-us', name: 'About Us' },
  { href: 'https://www.fca.org.uk/', name: 'FCA' },
  { href: '/complaints-process', name: 'Complaints process' },
]
